// eslint-disable-next-line @typescript-eslint/no-var-requires
const {Surface} = require('gl-react-dom');

export default Surface;
